<template>
  <div class="mainbody" v-cloak>
    <div id="app">
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>客户管理</el-breadcrumb-item>
          <el-breadcrumb-item>客户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                v-if="flagAdd"
                icon="el-icon-plus"
                @click="addLinkUrl"
                >新增</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="search-box">
              <el-input placeholder="输入客户名称，关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" width="250">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyFullName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column label="简称" width="130">
              <template slot-scope="scope">
                {{ scope.row.companyName }} | {{ scope.row.companySuffix }}
              </template>
            </el-table-column>

            <el-table-column label="联系人" width="90">
              <template slot-scope="scope">
                {{ scope.row.contactName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contactMobile"
              label="联系电话"
            ></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="gmtCreate" label="时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-view"
                  title="设备列表"
                  v-if="flagLook"
                  @click="copyLinkUrl(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  title="编辑"
                  v-if="flagUpdate"
                  @click="linkUrl(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  title="删除"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteItem(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        @closed="dialogClose"
        size="small"
      >
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      dialogVisible: false,
      flagAdd: false,
      flagDel: false,
      flagLook: false,
      flagUpdate: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "客户管理"
        );
        if (obj.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    dialogShow: function (_id) {
      this.dialogVisible = true;
    },
    dialogClose: function () {
      this.dialogVisible = false;
    },
    //加载图片地址
    loadImage: function (src) {
      if (!src.startsWith("/")) return src;
      return baseApi + src;
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/company/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&companyFullNameLike=" + encodeURI(_this.keyword);
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          //_this.pageSize = res.data.data.size;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    addLinkUrl() {
      this.$router.push({ name: "CompanyEdit" });
    },
    copyLinkUrl(companyId) {
      this.$router.push({
        name: "CabinetCabinetList",
        query: { companyId: companyId },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "CompanyEdit", query: { id: url } });
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/company/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>


// WEBPACK FOOTER //
// src/components/Company/CompanyList.vue